module.exports = __webpack_public_path__ + "img/slogan.fe656ece.webp";